
import {ConnectedComponent} from 'lowkey-component';
import {ImageLoader, ImageResource} from '@lib/../services/loader/ImageLoader';
import {MediaQueryScreenMode} from '@services/types';
import {appSelectors} from '@store/appSlice';

export class PreloadImage extends ConnectedComponent {
  private loader = ImageLoader.create();
  private img: HTMLElement | null = null;
  private mediaQueryScreenMode: MediaQueryScreenMode | undefined = undefined;

  constructor(element: HTMLDivElement) {
    super(element);
    this.imageLoaded = this.imageLoaded.bind(this);
  }

  didMount() {
    this.mediaQueryScreenMode = this.observe(
      appSelectors.selectMediaQueryScreenMode,
      this.changeMediaQuery.bind(this),
    );
    this.img = this.element?.querySelector(
      '.a-preload-image_img',
    ) as HTMLImageElement;
    this.load();
  }

  changeMediaQuery(mode?: MediaQueryScreenMode) {
    this.mediaQueryScreenMode = mode;
    this.load();
  }

  private getSrc() {
    const defaultSrc = this.img?.getAttribute('data-src');
    const mode = this.mediaQueryScreenMode === 'desktop' ? '-desktop' : '';
    const ret = this.img?.getAttribute(`data-src${mode}`);
    return ret || defaultSrc;
  }

  private async load() {
    const src = this.getSrc();
    if (src) {
      const resource = await this.loader.get(src);
      resource && this.imageLoaded(resource);
    }
  }

  private imageLoaded(resource: ImageResource) {
    const element = resource.element?.cloneNode(true) as HTMLElement;
    if (this.img && element) {
      Array.from(this.img.attributes)
        .filter((attr) => attr.nodeName !== 'src')
        .map(
          (attr) =>
            attr.nodeValue &&
            element.setAttribute(attr.nodeName, attr.nodeValue),
        );
      this.img && this.element?.replaceChild(element, this.img);
      this.img = element;
    }
  }
}
